<div class="row medium-14-16">
  <div class="col-4">Vessel name</div>
  <div class="col-4">IMO number</div>
  <div class="col-4">CRN</div>
</div>
<div class="row regular-14-16">
  <div class="col-4">{{selection.vesselName}}</div>
  <div class="col-4">{{selection.imo}}</div>
  <div class="col-4">{{selection.crn}}</div>
</div>
<div class="row" style="height: 1rem">
</div>
<div class="row medium-14-16">
  <div class="col-4">Berth</div>
  <div class="col-4">Arrival</div>
  <div class="col-4">Departure</div>
</div>
<div class="row regular-14-16">
  <div class="col-4">{{selection.berthName}}</div>
  <div class="col-4">{{selection.startTime | timestamp}}</div>
  <div class="col-4">{{selection.endTime | timestamp}}</div>
</div>
